import React, {Component} from 'react';
import {
  SimpleShowLayout,
  SingleFieldList,
  ReferenceInput,
  SelectInput,
  Filter,
  Labeled,
  ShowButton,
  ReferenceManyField,
  TextInput,
  List,
  Show,
  TabbedShowLayout,
  Tab,
  Datagrid,
  TextField,
  ReferenceField,
  UPDATE,
  Pagination,
  ListButton,
  Link
} from 'react-admin';
import { InfoReferences } from './info';
import $ from 'jquery';
import {Card, CardContent, CardHeader, Button, TextField as MTextField} from '@material-ui/core';
import { showNotification as showNotificationAction, refreshView as refreshViewAction } from 'react-admin';
import { connect } from 'react-redux';
import { get } from './authProvider';
import Switch from '@material-ui/core/Switch';
import ToggleOptions from './ToggleOptions';
import {dataProvider} from "./dataProvider";
import {TrailReferences} from "./trail";
import MVaultTools from './MVaultTools';
import SalesforceTools from './SalesforceTools';


const EmailField = (props) => {
  let { provider, provider_id, data } = props.record;

  let value = '';
  if (provider === 'password') {
    value = provider_id;
  } else if (provider === 'pbs') {
    value = data.owner.email;
  }

  return <span {...props}>{value}</span>;
};

const PBSField = (props) => {
  if (props.record.provider !== 'pbs') {
    return null;
  }

  return [
    <VPPAField {...props} key="vppa" />,
    <br key="space" />,
    <SignInMethod {...props} key="method" />
  ];
};

const VPPAField = (props) => {
  let { data } = props.record;
  return <Labeled label="Has accepted VPPA?">
    <span {...props}>{data && data.owner && data.owner.vppa && data.owner.vppa.vppa_accepted ? 'Yes' : 'No'}</span>
  </Labeled>;
};

const SignInMethod = (props) => {
  let { data } = props.record;
  return <Labeled label="Sign in method">
    <span {...props}>{data && data.signInMethod ? data.signInMethod : ''}</span>
  </Labeled>;
};

const AuthListFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Uuid" source="uuid" />
    <TextInput label="Email" source="email" />
    <TextInput label="Provider" source="provider" />
    <ReferenceInput label="Site" source="user_id" reference="user" allowEmpty>
      <SelectInput optionText="domain" />
    </ReferenceInput>
  </Filter>
);

export const AuthList = (props) => (
  <List {...props} filters={<AuthListFilters />} bulkActions={false}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="uuid" />
      <TextField source="email" />
      <TextField source="provider" />
      <TextField source="provider_id" />
      <ReferenceField label="Site" source="user_id" reference="user">
        <TextField source="domain" />
      </ReferenceField>
      <ShowButton />
    </Datagrid>
  </List>
);

export const authCardStyle = {
  width: 'calc(50% - 1rem)',
  margin: '0.5rem',
  display: 'inline-block',
  verticalAlign: 'top',
  boxSizing: 'border-box'
};

const activityStyle = {
  width: 'calc(50% - 1rem)',
  margin: '0.5rem',
  display: 'inline-block',
  boxSizing: 'border-box'
};

const SFData = (props) => {
  if (props.data) {
    let keys = Object.keys(props.data);

    for (let i in keys) {
      let k = keys[i];
      if (props.data[k] && props.data[k].label === 'salesforce') {
        let {id, contact_cid} = props.data[k].data;

        return <Labeled label="SalesForce">
          <a
            href={`https://tpt.lightning.force.com/lightning/r/Contact/${id}/view`}
            target="_blank" rel="noopener noreferrer">{contact_cid}</a>
        </Labeled>;
      }
    }
  }

  return null;
};

const MVaultData = (props) => {
  if (props.data) {
    let keys = Object.keys(props.data);

    for (let i in keys) {
      let k = keys[i];
      if (props.data[k] && props.data[k].label === 'mvault') {
        let {membership_id} = props.data[k].data;

        return <Labeled label="MVault">
          <span>{membership_id}</span>
        </Labeled>;
      }
    }
  }

  return null;
};

const AuthCards = (props) => {
  return [
    <Card key="identification" style={authCardStyle}>
      <CardHeader title="Identification" subheader="Site level identification details" />
      <CardContent>
        <SimpleShowLayout {...props}>
        <TextField source="id" />
        <ReferenceField label="Site" source="user_id" reference="user">
          <TextField label="Domain" source="domain" />
        </ReferenceField>
        <TextField source="uuid" />
        </SimpleShowLayout>
      </CardContent>
    </Card>,
    <Card key="activity" style={authCardStyle}>
      <CardHeader title="Account Activity" subheader="Account activity dates" action={<LockToggle {...props} />}/>
      <CardContent>
        <SimpleShowLayout style={activityStyle} {...props}>
          <TextField source="verification_sent_at" />
          <TextField source="last_authenticated_at" />
        </SimpleShowLayout>
        <SimpleShowLayout style={activityStyle} {...props}>
          <TextField source="created_at" />
          <TextField source="updated_at" />
        </SimpleShowLayout>
      </CardContent>
    </Card>,
    <Card key="provider" style={authCardStyle}>
      <CardHeader title="Provider" subheader="Login provider details" />
      <CardContent>
        <SimpleShowLayout {...props}>
          <Labeled label="Email">
            <EmailField  />
          </Labeled>
          <PBSField />
          <TextField source="provider" />
          <TextField label="Provider Id" source="provider_id" />
        </SimpleShowLayout>
      </CardContent>
    </Card>,
    <Card key="info" style={authCardStyle}>
      <CardHeader title="Info" subheader="Information shortcuts" />
      <CardContent>
        <SimpleShowLayout {...props}>
          <ReferenceManyField filter={{label: 'salesforce'}} label={null} reference="info" target="auth_id">
            <SFData/>
          </ReferenceManyField>
          <ReferenceManyField filter={{label: 'mvault'}} label={null} reference="info" target="auth_id">
            <MVaultData/>
          </ReferenceManyField>
        </SimpleShowLayout>
      </CardContent>
    </Card>
  ];
};

class AccountLockToggle extends Component {
  handleChange = (e, checked) => {
    let { record: { id }, refreshView, showNotification } = this.props;

    dataProvider(UPDATE, 'auth', { id, data: { is_locked: checked } })
      .then(() => {
        showNotification('account lock ' + (checked ? 'enabled' : 'disabled'));
      })
      .catch((e) => {
        console.log(e);
        showNotification('Error: Failed to ' + (checked ? 'lock' : 'unlock') + ' account', 'warning');
      })
      .finally(() => {
        refreshView();
      });
  };

  render() {
    const { record: { is_locked } } = this.props;
    return <span>
      <Switch checked={is_locked} onChange={this.handleChange} /> { is_locked ? 'Locked' : 'Unlocked'}
    </span>;
  }
}

let LockToggle = connect(null, { refreshView: refreshViewAction, showNotification: showNotificationAction })(AccountLockToggle);

const Tools = (props) => {
  return [
    <ToggleOptions key="flags" title={"Features"} subheader={"Enable/disable feature flags"} {...props} style={authCardStyle} />,
    <MVaultTools key="mvault" {...props} />,
    <SalesforceTools key="salesforce" {...props} />
  ];
};

export const AuthShow = (props) => {
  let trailUrl = `/trail?filter=%7B"auth_id"%3A"${props.id}"%7D&order=DESC&page=1&perPage=10&sort=id`;

  return <Show title={props.uuid} {...props}>
    <TabbedShowLayout>
      <Tab label="Auth">
        <AuthCards/>
      </Tab>
      <Tab label="Info">
        <ReferenceManyField label="Data" reference="info" target="auth_id">
          <InfoReferences/>
        </ReferenceManyField>
      </Tab>
      <Tab label="Tools">
        <Tools/>
      </Tab>
      <Tab label="Trail">
        <ReferenceManyField label="Auth Trail" reference="trail" target="auth_id" perPage={10} {...this.props}>
          <TrailReferences/>
        </ReferenceManyField>
        <Link to={trailUrl} variant="contained" color="primary">View all</Link>
      </Tab>
    </TabbedShowLayout>
  </Show>
};


// WEBPACK FOOTER //
// ./resources/assets/js/auth.js